import log, { LoggingLevel } from "../../core/log.js";
import Uploader from "../../core/upload/uploader.js";
import { DEFAULT_UPLOAD_TIMEOUT_MS, UploadResult } from "../../core/upload/uploader.js";
const LOG_TAG = "platform.browser.SendBeaconUploader";
class BrowserSendBeaconUploader extends Uploader {
    constructor() {
        super(...arguments);
        this.timeoutMs = DEFAULT_UPLOAD_TIMEOUT_MS;
    }
    async post(url, pingRequest, errorLog = true) {
        const wasQueued = navigator.sendBeacon(url, pingRequest.payload);
        if (wasQueued) {
            return new UploadResult(2, 200);
        }
        if (errorLog) {
            log(LOG_TAG, "The `sendBeacon` call was not serviced by the browser. Deleting data.", LoggingLevel.Error);
        }
        return new UploadResult(1);
    }
    supportsCustomHeaders() {
        return false;
    }
}
export default new BrowserSendBeaconUploader();
